"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Tooltip = _interopRequireDefault(require("../../components/tooltip/Tooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var INTERNATIONAL_COUNTRY_NOT_LISTED = {
  component: _Tooltip["default"],
  extra: true,
  name: 'international_country_not_listed_tooltip',
  props: {
    id: 'internationalCountryNotListedTooltip',
    buttonLabel: 'My country is not listed',
    icon: true
  }
};
var _default = exports["default"] = INTERNATIONAL_COUNTRY_NOT_LISTED;